import { CustomWindow } from '@utils/models/customwindow';
import { IYouTube } from './IYouTube';
import { IYouTubeEvent } from './IYouTubeEvent';
import { IYouTubePlayer } from './IYouTubePlayer';

declare let window: CustomWindow;

const youTubeObject: IYouTube = {
    initialized: false,
    players: [],

    initialize: function(onLoad: () => void) {
        const apiScriptId = "youtube-iframe-api";
        const hasMarketingConsent = window.Cookiebot?.consent?.marketing;

        if (!this.initialized && hasMarketingConsent && !document.getElementById(apiScriptId)) {
          const hasYoutubePlayers = document.querySelectorAll(".video-block__content--youtube").length > 0;

          if (hasYoutubePlayers) {
            const tag = document.createElement("script");
            const firstScriptTag = document.querySelector("script");

            tag.src = "https://www.youtube.com/iframe_api";
            tag.id = apiScriptId;
            tag.onload = onLoad;

            if (firstScriptTag) {
              firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
              this.initialized = true;
            }
          }
        } else if (this.initialized && hasMarketingConsent) {
            onLoad();
        }
    },

    createPlayer: function (videoId: string | undefined, ytPlayerId: string | undefined, onPlayerStateChange: Function) {
        const player = new window.YT.Player(ytPlayerId, {
            videoId: videoId,
            playerVars: {
                playsinline: 1,
                rel: 0,
            },
            events: {
                onReady: (event: IYouTubeEvent) => {
                    if (document.querySelector("body")?.classList.contains("isIOS")) {
                        event.target.mute();
                    }

                    event.target.playVideo();
                },
                onStateChange: (event: unknown) => {
                    onPlayerStateChange(event, ytPlayerId);
                },
            },
        });

      this.players.push({ ytPlayerId: ytPlayerId, player: player });
    },

  playYouTubeVideo: function(blockElement: HTMLElement) {
    const playerObject: IYouTubePlayer | undefined = this.players.find(({ ytPlayerId }) => (
      ytPlayerId == blockElement.dataset.containerid),
    );

    if (playerObject) {
      playerObject.player.playVideo();
    }
  },
};

window.KnowitOptimizelyFramework.YouTube = youTubeObject;